var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        title: "Import RFI with A.I.",
        size: "lg",
        "hide-footer": true,
        "no-close-on-backdrop": "",
        "header-class": "rfi-import-header"
      },
      on: { hidden: _vm.onHidden },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function() {
            return [
              _c(
                "h5",
                {
                  staticStyle: {
                    margin: "0",
                    "font-weight": "600",
                    color: "#1b2a4a"
                  }
                },
                [_vm._v("\n      Import RFI with A.I.\n    ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  staticStyle: { color: "#1b2a4a", opacity: "0.8" },
                  attrs: { type: "button", "aria-label": "Close" },
                  on: { click: _vm.close }
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×")
                  ])
                ]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _vm.phase === "upload"
        ? _c("div", [
            _c("p", { staticClass: "text-muted" }, [
              _vm._v(
                "\n      Upload any site-selector RFI — Excel, Word, or PDF, in any format. Lasso reads it and\n      builds a template of categories and questions for you to review.\n    "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "rfi-import-drop",
                class: {
                  "rfi-import-drop--over": _vm.dragOver,
                  "rfi-import-drop--disabled": !_vm.importAvailable
                },
                on: {
                  dragover: function($event) {
                    $event.preventDefault()
                    _vm.dragOver = _vm.importAvailable
                  },
                  dragleave: function($event) {
                    $event.preventDefault()
                    _vm.dragOver = false
                  },
                  drop: function($event) {
                    $event.preventDefault()
                    return _vm.onDrop($event)
                  },
                  click: function($event) {
                    _vm.importAvailable && _vm.$refs.fileInput.click()
                  }
                }
              },
              [
                _c("div", { staticClass: "rfi-import-drop__icons" }, [
                  _vm._v("\n        " + _vm._s(_vm.acceptedLabel) + "\n      ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "rfi-import-drop__label" }, [
                  _vm._v(
                    "\n        Drop a file here, or click to browse\n      "
                  )
                ]),
                _vm._v(" "),
                _c("input", {
                  ref: "fileInput",
                  staticClass: "d-none",
                  attrs: { type: "file", accept: _vm.accept },
                  on: { change: _vm.onFilePicked }
                })
              ]
            ),
            _vm._v(" "),
            _vm.tokensLoaded
              ? _c(
                  "div",
                  {
                    staticClass: "rfi-import-tokens",
                    class: { "text-danger": !_vm.importAvailable }
                  },
                  [
                    _vm.importAvailable
                      ? [
                          _vm._v("\n        This import will spend "),
                          _c("strong", [_vm._v("1 token")]),
                          _vm._v(
                            " (" +
                              _vm._s(_vm.importTokens) +
                              " remaining).\n      "
                          )
                        ]
                      : [
                          _vm._v(
                            "\n        No tokens remaining — contact support to add tokens to your account.\n      "
                          )
                        ]
                  ],
                  2
                )
              : _vm._e()
          ])
        : _vm.phase === "uploading"
        ? _c(
            "div",
            { staticClass: "text-center py-4" },
            [
              _c("b-spinner", { staticClass: "mb-3" }),
              _vm._v(" "),
              _c("div", { staticClass: "text-muted" }, [
                _vm._v("\n      Uploading "),
                _c("strong", [_vm._v(_vm._s(_vm.fileName))]),
                _vm._v("…\n    ")
              ])
            ],
            1
          )
        : _vm.phase === "sheets"
        ? _c("RfiSheetSelect", {
            attrs: { file: _vm.pendingFile },
            on: { confirm: _vm.onSheetsConfirmed, cancel: _vm.resetToUpload }
          })
        : _vm.phase === "pages"
        ? _c("RfiPageSelect", {
            attrs: { file: _vm.pendingFile },
            on: { confirm: _vm.onPagesConfirmed, cancel: _vm.resetToUpload }
          })
        : _vm.phase === "started"
        ? _c(
            "div",
            { staticClass: "text-center py-4" },
            [
              _c("b-icon", {
                staticClass: "mb-3",
                attrs: {
                  icon: "check-circle",
                  type: "is-success",
                  size: "is-large"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "font-weight-bold mb-1" }, [
                _vm._v("\n      Import started\n    ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-muted mb-3" }, [
                _vm._v("\n      We're reading "),
                _c("strong", [_vm._v(_vm._s(_vm.fileName))]),
                _vm._v(
                  " and building your template. You can keep\n      working — we'll notify you when it's ready to review.\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-2",
                      attrs: { variant: "primary" },
                      on: { click: _vm.close }
                    },
                    [_vm._v("\n        Got it\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "link", size: "sm" },
                      on: { click: _vm.goToDashboard }
                    },
                    [_vm._v("\n        View all imports\n      ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.phase === "error"
        ? _c(
            "div",
            { staticClass: "py-3" },
            [
              _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
                _vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-content-end" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-2",
                      attrs: { variant: "light" },
                      on: { click: _vm.resetToUpload }
                    },
                    [_vm._v("\n        Try another file\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary" },
                      on: { click: _vm.close }
                    },
                    [_vm._v("\n        Close\n      ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }